module.exports = __webpack_public_path__ + "img/5.dd76c4ae.png";